import CEO from "../assets/leaders/gray-user-profile-icon-png-fP8Q1P.png";

export const ceo_message = {
	name: "Gunjan Sighania",
	role: "Chief Executive Officer",
	img: CEO,
	message:
		"We believe that over the years we have created a strong foundation on which we can have sustainable long-term growth.Much as we desired, we are proud to be one of the top infrastructure & Trading companies for Railway Sector in India with the customer’s first choice by timely completion of contracts with outstanding presentation, excellent quality and reliability of our services at globally competitive cost. Motivated by vision and powered by our commitments, the growth and expansion has been the key to our success and would continue to do so in future.",
};
